import { useState } from "react";
import { classNames } from "primereact/utils";
import styles from "./EmployeeCard.module.scss";
import { IEmployeeAvailability } from "../../../models";
import { RenderWhen } from "../../../../../../common/infrastructure/components/RenderWhen";
import { EmployeePortfolioDialog } from "../EmployeePortfolioDialog/EmployeePortfolioDialog";

interface IEmployeeCardProps {
  employee: IEmployeeAvailability;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
  serviceId?: number;
  studioId?: number;
}

export const EmployeeCard = ({
  employee,
  isSelected,
  onClick,
  className,
  serviceId,
  studioId,
}: IEmployeeCardProps) => {
  const [isPortfolioOpen, setIsPortfolioOpen] = useState(false);

  // Use avatar if available, otherwise first letter of name
  const getAvatarContent = (): string => {
    if (employee.avatar) {
      return employee.avatar;
    }
    return employee.name.charAt(0).toUpperCase();
  };

  const isDisabled = !employee.isAvailable;
  // The "any professional" pseudo-option uses id === -1 and never has a portfolio.
  const showPortfolioButton = !!employee.hasPortfolio && employee.id > 0;

  const handleClick = () => {
    if (!isDisabled) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!isDisabled && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onClick();
    }
  };

  const handlePortfolioClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsPortfolioOpen(true);
  };

  return (
    <div
      className={classNames(
        styles.employeeCard,
        {
          [styles.selected]: isSelected,
          [styles.disabled]: isDisabled,
        },
        className
      )}
      onClick={handleClick}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      onKeyDown={handleKeyDown}
      aria-disabled={isDisabled}
    >
      <div className={styles.employeeAvatar}>{getAvatarContent()}</div>

      <div className={styles.employeeName}>{employee.name}</div>

      <RenderWhen condition={!!employee.role}>
        <div className={styles.employeeTitle}>{employee.role}</div>
      </RenderWhen>

      <RenderWhen condition={showPortfolioButton}>
        <button
          type="button"
          className={styles.portfolioButton}
          onClick={handlePortfolioClick}
        >
          Виж портфолио
        </button>
      </RenderWhen>

      <RenderWhen condition={isPortfolioOpen}>
        <EmployeePortfolioDialog
          isOpen={isPortfolioOpen}
          onClose={() => setIsPortfolioOpen(false)}
          employeeId={employee.id}
          employeeName={employee.name}
          serviceId={serviceId}
          studioId={studioId}
        />
      </RenderWhen>
    </div>
  );
};
